<template>
  <ModalContainer :show="show" @close="onCancel">
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></LoadingPlugin>

    <template slot="header">
      <h4 class="mb-0">
        {{ this.editPOI.id ? $t("edit_poi") : $t("create_poi") }}
      </h4>
    </template>
    <template slot="body">
      <div class="m-b-30">
        <p class="w-75">
          {{ $t("create_poi_description") }}
        </p>
      </div>
      <!-- <div class="action-summary">
        <p>
          {{ $t("drag_map_description") }}
        </p>
      </div> -->
      <form @submit.prevent="doAddPOI" class="">
        <div class="form-group">
          <label for="">{{ $t("name") }}</label>
          <input
            type="text"
            class="form-control"
            v-model="name"
            required
            :disabled="editPOI.id"
          />
        </div>

        <div class="form-group" v-if="!useMap">
          <label for="">{{ $t("latitude") }}</label>
          <input
            type="text"
            class="form-control"
            v-model.number="latitude"
            required
          />
        </div>

        <div class="form-group" v-if="!useMap">
          <label for="">{{ $t("longitude") }}</label>
          <input
            type="text"
            class="form-control"
            v-model.number="longitude"
            required
          />
        </div>

        <div class="d-flex col-gap-1 align-items-center">
          <input type="checkbox" v-model="useMap" />
          <p class="mb-0">
            {{ $t("select_poi_on_map") }}
          </p>
        </div>

        <div class="form-group">
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary">
              {{ $t("create") }}
            </button>
          </div>
        </div>
      </form>
      <!-- <div class="poi-header" v-if="POI.length > 0">
        {{ $t("other_pois") }}
      </div>
      <div style="max-height: 300px; overflow-y:auto" class="mt-3">
        <div
          :key="POI._id"
          v-for="POI in POI"
          class="device-container d-flex justify-content-between align-items-center mb-3 p-4"
        >
          <div>
            {{ POI.name }}
          </div>
          <div class="delete-poi" @click="deletepoi(POI._id)">
            {{ $t("delete") }}
          </div>
        </div>
      </div> -->
    </template>
  </ModalContainer>
</template>

<script>
// import IconCancel from "./Iconsvg/IconCancel";
import { mapActions, mapGetters } from "vuex";
import ModalContainer from "./ModalContainer.vue";
import LoadingPlugin from "vue-loading-overlay";

export default {
  name: "CreatePOI",
  props: {
    show: Boolean,
    editPOI: Object,
  },
  // components: {
  //   IconCancel,
  // },
  data() {
    return {
      name: "",
      useMap: true,
      longitude: null,
      latitude: null,
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters(["POI"]),
  },
  methods: {
    ...mapActions(["addPOI", "editpoi"]),
    onCancel() {
      this.$emit("closeCreatePOI");
    },
    doAddPOI() {
      if (this.useMap) {
        this.$emit("addPOI", this.name);
        this.name = "";
      } else {
        this.isLoading = true;
        const newMarker = {
          position: { lat: this.latitude, lng: this.longitude },
          name: this.name,
          // draggable: true,
        };
        if (this.editpoi.id) {
          return this.editPOI({ POI: newMarker, id: this.editPOI.id })
            .then(() => {
              // this.POI.push(newMarker);
              this.isLoading = false;
              // console.log(this.POI, "poi updated");
              this.$emit("poi-added");
            })
            .catch((err) => console.error(err));
        }
        this.addPOI({ POI: newMarker })
          .then(() => {
            // this.POI.push(newMarker);
            this.isLoading = false;
            // console.log(this.POI, "poi updated");
            this.$emit("poi-added");
          })
          .catch((err) => console.error(err));
      }
      // this.$emit("closeCreatePOI");
    },
    deletepoi(id) {
      this.$emit("delete-POI", id);
      // this.deletePOI(id).then(() => {
      //   this.fetchPOI().then(() => {
      //     console.log("fetched");
      //   });
      // });
    },
  },
  components: { ModalContainer, LoadingPlugin },
  watch: {
    editPOI() {
      if (this.editPOI.id) {
        this.name = this.editPOI.name;
        this.latitude = this.editPOI.position.lat;
        this.longitude = this.editPOI.position.lng;
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 300px;
  background: #fff;
  position: absolute;
  right: 0;
  top: 64px;
  height: calc(100% - 64px);
  padding: 28px 20px;
  display: none;
  /* overflow: hidden; */
  transition: 0.3s ease-out;
  z-index: 2000;
  overflow-y: auto;
}
.container.show {
  display: block;
}
.action-summary {
  padding: 10px;
  background: #f2f5f7;
  margin-bottom: 26px;
}
.btn-maps {
  /* background: #f2f5f7; */
  padding: 10px 23px;
  /* color: #30b24b; */
  /* border: 1px solid #e1e7ec; */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  outline: none;
}
.device-container {
  height: 50px;
  /* border-bottom: ; */
  box-shadow: 0px 1px 0px #e1e7ec;
}
.delete-poi {
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  color: #2980b9;
}
.poi-header {
  padding-left: 10px;
  font-style: italic;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #2980b9;
}
</style>
